export * from "./hotel-faq";
export * from "./hotel-faq.types";
